import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
const services = [{
  title: 'MunisVerse Inspect',
  description: 'Virtual inspections on demand for individuals and corporates. Explore properties remotely before committing to a physical visit.',
  image: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?q=80&w=2070&auto=format&fit=crop'
}, {
  title: 'MunisVerse Capture',
  description: 'Professional property digitization and virtual scanning services for owners, developers, and estate managers.',
  image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?q=80&w=2096&auto=format&fit=crop'
}, {
  title: 'MunisVerse Gallery',
  description: 'A curated virtual property gallery offering exclusive, high-end listings for verified real estate professionals only.',
  image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2070&auto=format&fit=crop'
}];
export function Services() {
  return <section id="services" className="py-32 bg-zinc-950" data-id="element-191">
      <div className="max-w-7xl mx-auto px-6" data-id="element-192">
        <FadeIn className="mb-20" data-id="element-193">
          <h2 className="text-4xl md:text-5xl font-display font-medium text-white mb-6" data-id="element-194">
            Three core services. <br data-id="element-195" />
            One immersive ecosystem.
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-196">
          {services.map((service, index) => <FadeIn key={index} delay={index * 0.1} className="group cursor-pointer" data-id="element-197">
              <div className="relative aspect-[4/5] rounded-3xl overflow-hidden mb-6" data-id="element-198">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-199" />
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/20 to-transparent opacity-80" data-id="element-200" />

                <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-201">
                  <h3 className="text-2xl font-display font-medium text-white mb-3" data-id="element-202">
                    {service.title}
                  </h3>
                  <p className="text-zinc-400 text-sm leading-relaxed mb-6 line-clamp-3" data-id="element-203">
                    {service.description}
                  </p>
                  <div className="flex items-center text-white text-sm font-medium group-hover:gap-3 transition-all" data-id="element-204">
                    Learn more <ArrowRight size={16} className="ml-2" data-id="element-205" />
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}